import { connect } from 'react-redux';
import ProductList from '../components/ProductList/ProductList';
import { requestProducts, setActivePage } from '../actions/productActions';
import {
    calculatePaginationPages,
    calculateTotalPages,
    getDisplayedData,
    getShowProductPrice,
} from '../selectors/converterSelector';

import {
    getShowNLISFilter,
    getShowNAITFilter,
} from '../selectors/productSelector';

const mapStateToProps = function(store) {
    return {
        hasInitialized: store.product.hasInitialized,
        isLoading: store.product.isLoading,
        list: getDisplayedData(store.product.listDisplay, store.product.list),
        activePage: store.product.listParams.activePage,
        totalRecords: store.product.listParams.totalRecords,
        totalPages: calculateTotalPages(store.product.listParams),
        paginationPages: calculatePaginationPages(store.product.listParams),
        viewType: store.product.viewType,
        showNLISFilter: getShowNLISFilter(store),
        showNAITFilter: getShowNAITFilter(store),
        currencyFormat: store.cart.currencyFormat,
        currencyDisplayCode: store.cart.currencyDisplayCode,
        locale: store.cart.locale,
    };
};
const mapDispatchToProps = function(dispatch, ownProps) {
    return {
        request: () => dispatch(requestProducts()),
        onPaginationClick: (pageNum) => dispatch(setActivePage(pageNum)),
    };
};
const ConnectedProductList = connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductList);

export default ConnectedProductList;
